import { useUpdateCompanyBalanceMutation } from "@/pages/Private/redux/company-balance/company-balance.api";

import { CompanyBalance, CompanyBalanceSchema } from "../../schema/company-balance";
import EditModeCompanyBalanceItem from "./EditableCompanyRevenueItem";
import ViewModeCompanyBalanceItem from "./ViewCompanyBalanceItem";

interface EditableCompanyBalanceItemProps {
	data: CompanyBalance;
	isEditing: boolean;
	isEditingInProcess: boolean;
	setEditing: (value: number) => void;
	setDeletingCompanyBalance: (value: CompanyBalance | null) => void;
}

export default function EditableCompanyBalanceItem({
	data,
	isEditing,
	setEditing,
	setDeletingCompanyBalance,
	isEditingInProcess,
}: EditableCompanyBalanceItemProps) {
	const [updateCompanyBalance, { isLoading }] = useUpdateCompanyBalanceMutation();

	const handleUpdateCompanyBalance = async (values: CompanyBalance) => {
		try {
			await updateCompanyBalance(values).unwrap();
		} catch (error) {
			console.error("An unexpected error occurred:", error);
		}
	};

	return isEditing ? (
		<EditModeCompanyBalanceItem
			data={data}
			isLoading={isLoading}
			setEditing={setEditing}
			validationSchema={CompanyBalanceSchema}
			onSubmit={handleUpdateCompanyBalance}
		/>
	) : (
		<ViewModeCompanyBalanceItem
			data={data}
			isEditingInProcess={isEditingInProcess}
			isLoading={false}
			setDeletingCompanyBalance={setDeletingCompanyBalance}
			setIsEditing={setEditing}
		/>
	);
}
